import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";
import axios from "axios";
// TODO: Change from Product to Sellable
@Singleton
export default class ProductService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination, group }) {
    const url = `/v1/companies/${companyUuid}/sellables`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination,
      group
    });
    return await this.get(resourceRoute);
  }

  async deleteAll(company_uuid) {
    return await this.post(`/v1/sellables/delete_all`, { company_uuid });
  }

  async restoreAll(company_uuid) {
    return await this.post(`/v1/sellables/restore_all`, { company_uuid });
  }

  async updateMany(companyUuid, products) {
    return await this.post(
      `/v1/companies/${companyUuid}/sellables/import`,
      products
    );
  }

  async fetchByUuid(companyUuid, productUuid) {
    return await this.get(
      `/v1/companies/${companyUuid}/sellables/${productUuid}`
    );
  }

  async getInventoryTotals(companyUuid) {
    return await this.get(`/v1/companies/${companyUuid}/stock_operations`);
  }

  async update(companyUuid, uuid, params) {
    return await super.update(
      `/v1/companies/${companyUuid}/sellables/${uuid}`,
      params
    );
  }

  async create(companyUuid, params) {
    return await this.post(`/v1/companies/${companyUuid}/sellables`, params);
  }

  async generateSkus(companyUuid) {
    return await this.post(`/v1/sellables/${companyUuid}/generate_variations`);
  }

  async deleteSkus(companyUuid) {
    return await this.post(`/v1/sellables/${companyUuid}/delete_variations`);
  }

  async updateInventoryCounting(companyUuid, params) {
    return await this.post(
      `/v1/companies/${companyUuid}/stock_operations`,
      params
    );
  }

  async importFile(params) {
    return await this.post("/v1/import_file", params);
  }

  async getImportStatus() {
    return await this.get("/v1/import_status");
  }

  async validateTaxes(params) {
    let response, success;
    try {
      response = await axios.get(process.env.REACT_APP_MONGO_NCM_VALIDATION, {
        params: {
          state: params.state,
          code: params.code,
          secret: process.env.REACT_APP_SECRET_NCM_VALIDATION
        }
      });
      success = true;
    } catch (e) {
      if (e instanceof axios.Cancel) {
        e.response = {
          ...(e.response || {}),
          data: { error: { userCancelled: true } }
        };
      }
      response = e.response;
      success = false;
    }

    const fatal = !response || response.status >= 500;
    const status = response ? response.status : 400;
    const data = fatal ? null : response.data;
    const headers = fatal ? null : response.headers;
    const errors =
      !!response && !!response.data.errors ? response.data.errors : [];

    return { fatal, status, data, headers, success, errors };
  }
}



// WEBPACK FOOTER //
// ./src/core/service/product.service.js